import React from 'react';

export default function CowHornsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="35.28,17.02 29.0,17.02 29.0,10.74 35.28,10.74" fill="#E4D9E4" />
      <polygon points="29.0,17.02 35.28,17.02 34.02,16.39 27.74,16.39" fill="#B99DB9" opacity="0.95" />
      <polygon points="29.0,17.02 27.74,16.39 27.74,10.11 29.0,10.74" fill="#B99DB9" opacity="0.95" />
      <polygon points="12.26,17.02 5.98,17.02 5.98,10.74 12.26,10.74" fill="#E4D9E4" />
      <polygon points="5.98,17.02 12.26,17.02 11.0,16.39 4.72,16.39" fill="#B99DB9" opacity="0.95" />
      <polygon points="5.98,17.02 4.72,16.39 4.72,10.11 5.98,10.74" fill="#B99DB9" opacity="0.95" />
      <polygon points="38.0,29.89 29.63,29.89 29.63,17.33 38.0,17.33" fill="#E4D9E4" />
      <polygon points="29.63,29.89 38.0,29.89 35.49,28.63 27.12,28.63" fill="#B99DB9" opacity="0.95" />
      <polygon points="29.63,29.89 27.12,28.63 27.12,16.08 29.63,17.33" fill="#B99DB9" opacity="0.95" />
      <polygon points="12.88,29.89 4.51,29.89 4.51,17.33 12.88,17.33" fill="#E4D9E4" />
      <polygon points="4.51,29.89 12.88,29.89 10.37,28.63 2.0,28.63" fill="#B99DB9" opacity="0.95" />
      <polygon points="4.51,29.89 2.0,28.63 2.0,16.08 4.51,17.33" fill="#B99DB9" opacity="0.95" />
    </svg>
  );
}
